module.exports = __webpack_public_path__ + "img/menu-header-image.53c4aa17.png";